export default function nav() {
  $.fn.focusItem = function () {
    if (this.length && this[0].focus) {
      this[0].focus();
    }
    return this;
  };

  var $header = $('#header-main'),
    $navMainToggle = $('.nav-main-toggle'),
    $navMainHeader = $('#nav-main-header'),
    $navMainMenu = $('#nav-main-menu'),
    $navMainInner = $('#nav-main-inner'),
    $navMainMenuParents = $navMainMenu.find('.parent'),
    $body = $('body'),
    lastScrollTop = 0,
    distanceFromTop = 1,
    delta = { up: 100, down: 2 },
    headerHeight,
    calculateHeaderClass = function () {
      let y = window.pageYOffset;
      headerHeight = $header.outerHeight();
      distanceFromTop = headerHeight > distanceFromTop ? headerHeight : distanceFromTop; //need to trigger at distance at least as tall as the header
      if (y - delta.down > lastScrollTop) {
        //keep track of tucked
        if (y > 1) {
          $header.addClass('tucked');
        }
        lastScrollTop = y;
      } else if (y + delta.up < lastScrollTop || y < delta.down) {
        $header.removeClass('tucked');
        lastScrollTop = y;
      }

      if (y < delta.down) {
        //keep track of top
        $header.addClass('top');
      } else if (y > delta.down) {
        $header.removeClass('top');
      }

      if (headerHeight < y) {
        $header.addClass('offscreen');
      } else {
        $header.removeClass('offscreen');
      }

      if (distanceFromTop < y) {
        $header.addClass('away-from-top');
      } else {
        $header.removeClass('away-from-top');
      }

      if (y - delta.down > lastScrollTop || y + delta.up < lastScrollTop)
        //keep track only outside of delta range
        lastScrollTop = y;
    },
    attachMenuEvents = function () {
      $navMainInner.attr('aria-expanded', 'false');
      $navMainToggle.on('click', function () {
        var isMenuOpen = $body.hasClass('nav-main-open');
        if (isMenuOpen) {
          $body.removeAttr('style');
          $header.removeAttr('style');
          $body.removeClass('nav-main-open');
          $navMainMenuParents.removeClass('active-path');
          $navMainInner.attr('aria-expanded', 'false');
        } else {
          //prevent content from shifting when nav is opened
          let w = $body.width();
          $body.css('width', w);
          $header.css('width', w);

          //nav header matches main header height
          headerHeight = $header.outerHeight();
          $navMainHeader.css('height', headerHeight);

          $body.addClass('nav-main-open');
          $navMainInner.attr('aria-expanded', 'true');

        }
      });
      $navMainToggle.on('keypress', function (e) {
        if ((e.keyCode ? e.keyCode : e.which) == 13) {
          $(this).trigger('click');
        }
      })
    },
    watchNavState = function () {
      
    },
    watchNavLevel = function () {
      $navMainMenuParents.filter('.active-path').length ? $navMainMenu.addClass('has-active-path') : $navMainMenu.removeClass('has-active-path');
    },
    closeAndCleanupNav = function () {
      $body.removeClass('nav-main-open');
      $navMainMenuParents.removeClass('active-path active-path-root');
      $navMainMenu.removeClass('has-active-path');
      $navMainInner.attr('aria-expanded', 'false');
    },
    focusNext = function ($ele) {
      $ele.closest('li').next('li')
        ? $ele.closest('li').next('li').children('a').focusItem()
        : $ele.closest('ul').find('li:first-child').children('a').focusItem();
    },
    focusPrevious = function ($ele) {
      $ele.closest('li').prev('li').length
        ? $ele.closest('li').prev('li').children('a').focusItem()
        : $ele.closest('ul').find('li:last-child').children('a').focusItem();
    },
    focusChild = function ($ele) {
      setTimeout(function () {
        $ele.next('ul').find('> li > a:not(.disabled), > li > :not(ul) a:not(.disabled)').eq(0).focusItem();
      }, 500);
    },
    focusParent = function ($ele) {
      setTimeout(function () {
        $ele.closest('.active-path-root').children('a').focusItem();
      }, 500);
    },
    focusMain = function ($ele) {
      setTimeout(function () {
        $ele.parents('li').last().children('a').focusItem();
      }, 500);
    },
    handleKeyDown = function (e) {
      let keyCode = e.keyCode,
        $target = $(e.target);
      //only listening for arrows, enter and space on anchors
      if (!/^(13|32|37|38|39|40)$/.test(keyCode) || !$target.is('a')) {
        return;
      }
      switch (keyCode) {
        case 13: //enter
        case 32: //space
          $target[0].click();
          if ($target.closest('li').hasClass('parent')) {
            focusChild($target);
          } else if ($target.closest('li').hasClass('back-to-parent')) {
            focusParent($target);
          } else if ($target.closest('li').hasClass('back-to-home')) {
            focusMain($target);
          }
          break;
        case 37: //left
          if ($target.closest('li').hasClass('back-to-parent')) {
            $target[0].click();
            focusParent($target);
          } else if ($target.closest('li').hasClass('back-to-home')) {
            $target[0].click();
            focusMain($target);
          }
          break;
        case 38: // Up
          focusPrevious($target);
          break;
        case 39: // Right
          if ($target.closest('li').hasClass('parent')) {
            $target[0].click();
            focusChild($target);
          }
          break;
        case 40: // Down
          focusNext($target);
          break;
      } //switch
      e.stopPropagation();
      e.preventDefault();
    },
    init = function () {
      //generate items not natural in menu hierarchy
      $navMainMenuParents.each(function () {
        let $this = $(this);

        //make a clickable item for parent item in each child menu
        //clicking on items with children opens the children.
        //This is where we can access the parent and also display the current section
        let $parentLink = $this.children('a').clone();
        $this.children('ul').prepend('<li class="active-path-parent"></li>').find('.active-path-parent').append($parentLink);

        //generate navigate back to parents (siblings) list
        let $parentsParent = $this.parent().closest('li.parent');
        if ($parentsParent.length) {
          //only if we are child of a child (3 levels)
          $this
            .children('ul')
            .prepend('<li class="back-to-parent"><a href="#">back</a></li>')
            .find('li.back-to-parent > a')
            .text($parentsParent.children('a').text())
            .on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              $this.removeClass('active-path').closest('.active-path').addClass('active-path-root');
              watchNavLevel();
            });
        }

        //generate navigate back home item
        $this
          .children('ul')
          .prepend('<li class="back-to-home"><a href="#">Main Menu</a></li>')
          .find('li.back-to-home > a')
          .on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $navMainMenuParents.removeClass('active-path active-path-root');
            watchNavLevel();
          });
      });

      //parents display children. children include parents link
      $navMainMenuParents.children('a').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let $this = $(this);
        if (Element.prototype.scroll) {
          $this.closest('ul')[0].scroll(0, 0); //move to the top of the menu
        } else {
          $this.closest('ul').scrollTop(0);
        }
        $navMainMenuParents.removeClass('active-path active-path-root');
        $this.parents('li').addClass('active-path');
        $this.closest('li').addClass('active-path-root');
        watchNavLevel();
      });

      calculateHeaderClass();
      watchNavState();
      attachMenuEvents();

      $(document).on('keydown.afpimsnav', '#nav-main-inner', handleKeyDown);
    };

  if (!$header) return;

  //utility classes added/removed based on what is going on
  $(window).on('scroll', function () {
    calculateHeaderClass();
  });

  //outside events that close the nav
  $('#nav-main-open-overlay').on('click', function (e) {
    e.stopPropagation();
    closeAndCleanupNav();
  });
  $(window).on('resize', function () {
    if (!iOS() && !isAndroid()) closeAndCleanupNav();
  }); //ios moves stuff around when scrolling and causes the resize event to trigger
  document.onkeydown = function (e) {
    //maybe move this to other key listeners
    e = e || window.event;
    let isEscape = false;
    'key' in e ? (isEscape = e.key === 'Escape' || e.key === 'Esc') : (isEscape = e.keyCode === 27);
    if (isEscape) closeAndCleanupNav();
  };

  function iOS() {
    return (
      ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }

  function isAndroid() {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1 || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  }

  init();
}
